const _ = require('lodash');
const GUEST_USER = {
    id: '',
    firstName: '',
    lastName: '',
    email: '',
    encodedEmail: undefined,
    encryptedEmail: undefined,
    fullName: '',
    dateOfBirth: '',
    phone: '',
    age: 0,
    isGuest: true,
    isStaffMember: false,
    hasEdrCard: false,
    edrNumber: '',
    orderCount: 0
};

const sha256 = require('js-sha256');
const STORAGE_KEY = 'shopperDetails';

function CurrentUserService(LocalStorageService, $window) {
    this._$local = LocalStorageService;
    const storageUser = this._$local.getItem(STORAGE_KEY);
    let user;
    if (_.isUndefined(storageUser) || _.isNull(storageUser)) {
       user = _.clone(GUEST_USER);
    } else {
       user = JSON.parse(storageUser);
    }

    if (!_.isUndefined($window.IsGuest)) user.isGuest = $window.IsGuest;
    this.currentUser = user;
    this._$local.setItem(STORAGE_KEY, JSON.stringify(user));
}

CurrentUserService.prototype.isLoggedIn = function () {
   return !this.currentUser.isGuest;
};

function encodeSha256(value) {
    return sha256(value);
}

CurrentUserService.prototype.set = function (user) {
    if (user && user.email && user.email.length > 0) {
        user.encodedEmail = encodeSha256(user.email);
    }
   _.merge(this.currentUser, user);
    this._$local.setItem(STORAGE_KEY, JSON.stringify(this.currentUser));
};

CurrentUserService.prototype.get = function () {
    return this.currentUser;
};

CurrentUserService.prototype.clear = function () {
    const freshGuest = _.clone(GUEST_USER);
    _.assign(this.currentUser, freshGuest);
    this._$local.setItem(STORAGE_KEY, JSON.stringify(freshGuest));
};

module.exports = CurrentUserService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/current-user-service.js
 **/